import styled from 'styled-components';
import { Text } from 'components/Atoms';

export const Image = styled.img`
  max-width: 100%;
  width: ${props => props.width};
  height: ${props => props.height || 'auto'};
  margin: ${props => props.margin || '0 auto'};
`;

export const Content = styled.div`
  position: absolute;
  left: 0;
  bottom: 80px;
  width: 100%;
`;

export const Title = styled(Text)`
  font-size: ${props => props.theme.old.fontSize.subtitle};
  font-weight: ${props => props.theme.old.fonts.weight.semibold};
  
  span {
    color: ${props => props.theme.old.colors.secondary};
  }
`;